import { useTranslation } from 'react-i18next'
import { MessageCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { useChat } from '../ChatProvider'
import { useChatPanel } from '../panel/chatPanelContext'

/**
 * 顶栏的 Messages 入口：开合右侧 Messages 侧边栏（与 AI 助手停靠面板同一套机制，打开到会话列表）。
 * 角标：未读条数（不含免打扰会话，同通知铃样式）；只有免打扰会话有未读时只显示一个红点（契约 §2.6）。
 * 只给有 system:chat:query 的人显示（capability chat.use），与 mobile 工具箱入口同一个门。
 */
export function ChatTopBarButton() {
  const { t } = useTranslation('chat')
  const { enabled, unread, mutedUnread } = useChat()
  const panel = useChatPanel()
  if (!enabled) return null
  const dot = unread <= 0 && mutedUnread > 0
  const label = unread > 0 ? `${t('title')} (${unread})` : dot ? `${t('title')} (${t('mutedUnreadA11y')})` : t('title')
  return (
    <Button
      ref={(el) => { panel.triggerRef.current = el }}
      variant="ghost"
      size="icon"
      className={cn('relative h-9 w-9 text-muted-foreground hover:bg-accent hover:text-foreground', panel.open && 'bg-accent text-foreground')}
      onClick={panel.toggle}
      title={t('title')}
      aria-label={label}
      aria-expanded={panel.open}
      data-testid="chat-topbar"
    >
      <MessageCircle className="h-4 w-4" />
      {unread > 0 ? (
        <span className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-destructive px-1 text-xs font-medium text-destructive-foreground" data-testid="chat-topbar-badge">
          {unread > 99 ? '99+' : unread}
        </span>
      ) : dot ? (
        <span className="absolute right-1 top-1 h-2.5 w-2.5 rounded-full bg-destructive ring-2 ring-background" data-testid="chat-topbar-dot" />
      ) : null}
    </Button>
  )
}
